import { useState, useEffect } from "react";

const useDeviceType = () => {
    const [device, setDevice] = useState({
        isMobile: false,
        isTablet: false,
        isDesktop: false
    });

    useEffect(() => {
        const checkDevice = () => {
            const width = window.innerWidth;
            setDevice({
                isMobile: width <= 767,      // Mobile: <= 767px
                isTablet: width > 767 && width <= 1024, // Tablet: 768px - 1024px
                isDesktop: width > 1024 // Desktop: > 1024px
            });
        };

        checkDevice();
        window.addEventListener("resize", checkDevice);
        return () => window.removeEventListener("resize", checkDevice);
    }, []);

    return device;
};

export default useDeviceType;
